import { Controller } from "@hotwired/stimulus"

// Opens a <details> panel when the page loads with a matching location hash.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    if (!this.element.id) return
    if (window.location.hash !== `#${this.element.id}`) return

    this.openPanel()
  }

  openPanel() {
    if (!this.hasPanelTarget) return
    if (this.panelTarget.tagName === "DETAILS") {
      this.panelTarget.open = true
    }
  }
}
